var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parsed-details d-flex flex-column"},_vm._l((_vm.keys.filter((key) =>
      Object.keys(_vm.document.parsed_details).includes(key),
    )),function(parsedDetailsType){return _c('parsed-detail-item',{key:parsedDetailsType,attrs:{"parsed-details-type":parsedDetailsType,"parsed-detail":_vm.document.parsed_details[parsedDetailsType]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }